const Reflux = require("reflux");
const LostDealsActions = require("../actions/lost-deals-actions");

const LostDealsStore = Reflux.createStore({
  state: {
    loading: true,
    failed: false,
    data: {
      count: 0,
      amount: 0,
      countDelta: 0,
      amountDelta: 0,
    }
  },

  init: function() {
    this.listenTo(LostDealsActions.fetchData, this.onFetchStarted);
    this.listenTo(LostDealsActions.fetchData.completed, this.onFetchCompleted);
    this.listenTo(LostDealsActions.fetchData.failed, this.onFetchFailed);

    this.state = this.getInitialState();
  },

  getInitialState: function() {
    return this.state;
  },

  onFetchStarted: function() {
    this.state = {
      loading: true,
      failed: false
    };

    this.trigger(this.state);
  },

  onFetchCompleted: function(data) {
    this.state = {
      loading: false,
      data: {
        count: data.count.value,
        amount: data.total_amount.value,
        countDelta: data.count.delta,
        amountDelta: data.total_amount.delta
      }
    };

    this.trigger(this.state);
  },

  onFetchFailed: function() {
    this.state = {
      loading: false,
      failed: true
    };

    this.trigger(this.state);
  }
});

module.exports = LostDealsStore;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/stores/lost-deals-store.js